/**
 * Created by Matthew Ary on 01/15/2018.
 */

export default {
  bgGradient: state => {
    return 'padding: 0px; background-image: radial-gradient(circle at center, ' + state.loginStart.hex + ' 20%, ' + state.loginEnd.hex + ' 120%);'
  },
  linkColor: state => {
    return 'color: ' + state.forgotLinkColor.hex + ';'
  }
}
